// extracted by mini-css-extract-plugin
module.exports = {"nounInfoHeader":"PunkInfoCard_nounInfoHeader__2doHy","nounInfoRow":"PunkInfoCard_nounInfoRow__2nleY","nounInfoRowText":"PunkInfoCard_nounInfoRowText__3nwD1"};